// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { areIntervalsOverlapping as fn } from "../areIntervalsOverlapping.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const areIntervalsOverlapping = convertToFP(fn, 2);

// Fallback for modularized imports:
export default areIntervalsOverlapping;
